import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/activities.js'), 'activities.js')
  resolveStoreModules(require('../store/applications.js'), 'applications.js')
  resolveStoreModules(require('../store/appointments.js'), 'appointments.js')
  resolveStoreModules(require('../store/bia.js'), 'bia.js')
  resolveStoreModules(require('../store/bodyscan.js'), 'bodyscan.js')
  resolveStoreModules(require('../store/cap.js'), 'cap.js')
  resolveStoreModules(require('../store/cardio.js'), 'cardio.js')
  resolveStoreModules(require('../store/circumference.js'), 'circumference.js')
  resolveStoreModules(require('../store/common.js'), 'common.js')
  resolveStoreModules(require('../store/config.js'), 'config.js')
  resolveStoreModules(require('../store/crumb.js'), 'crumb.js')
  resolveStoreModules(require('../store/dashboard.js'), 'dashboard.js')
  resolveStoreModules(require('../store/dictionary.js'), 'dictionary.js')
  resolveStoreModules(require('../store/digitalMeasurements.js'), 'digitalMeasurements.js')
  resolveStoreModules(require('../store/docs.js'), 'docs.js')
  resolveStoreModules(require('../store/exams.js'), 'exams.js')
  resolveStoreModules(require('../store/fitness.js'), 'fitness.js')
  resolveStoreModules(require('../store/fitnessGroup.js'), 'fitnessGroup.js')
  resolveStoreModules(require('../store/fitnessPatients.js'), 'fitnessPatients.js')
  resolveStoreModules(require('../store/fitnessReports.js'), 'fitnessReports.js')
  resolveStoreModules(require('../store/functions.js'), 'functions.js')
  resolveStoreModules(require('../store/group.js'), 'group.js')
  resolveStoreModules(require('../store/groups.js'), 'groups.js')
  resolveStoreModules(require('../store/history.js'), 'history.js')
  resolveStoreModules(require('../store/keto.js'), 'keto.js')
  resolveStoreModules(require('../store/ketoGroup.js'), 'ketoGroup.js')
  resolveStoreModules(require('../store/ketoPatients.js'), 'ketoPatients.js')
  resolveStoreModules(require('../store/ketoReports.js'), 'ketoReports.js')
  resolveStoreModules(require('../store/measurementHBO.js'), 'measurementHBO.js')
  resolveStoreModules(require('../store/measurements.js'), 'measurements.js')
  resolveStoreModules(require('../store/messages.js'), 'messages.js')
  resolveStoreModules(require('../store/network.js'), 'network.js')
  resolveStoreModules(require('../store/nutrilabProManager.js'), 'nutrilabProManager.js')
  resolveStoreModules(require('../store/patient.js'), 'patient.js')
  resolveStoreModules(require('../store/patients.js'), 'patients.js')
  resolveStoreModules(require('../store/print.js'), 'print.js')
  resolveStoreModules(require('../store/profile.js'), 'profile.js')
  resolveStoreModules(require('../store/provinces.js'), 'provinces.js')
  resolveStoreModules(require('../store/regional.js'), 'regional.js')
  resolveStoreModules(require('../store/regionalGroup.js'), 'regionalGroup.js')
  resolveStoreModules(require('../store/regionalPatients.js'), 'regionalPatients.js')
  resolveStoreModules(require('../store/regionalReports.js'), 'regionalReports.js')
  resolveStoreModules(require('../store/reports.js'), 'reports.js')
  resolveStoreModules(require('../store/sessions.js'), 'sessions.js')
  resolveStoreModules(require('../store/skinfold.js'), 'skinfold.js')
  resolveStoreModules(require('../store/training.js'), 'training.js')
  resolveStoreModules(require('../store/ui.js'), 'ui.js')
  resolveStoreModules(require('../store/user.js'), 'user.js')
  resolveStoreModules(require('../store/utils.js'), 'utils.js')
  resolveStoreModules(require('../store/virtualAssistant.js'), 'virtualAssistant.js')
  resolveStoreModules(require('../store/bluetooth/index.js'), 'bluetooth/index.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
